import { render } from "./StudentMoreInfoView.vue?vue&type=template&id=f4c1f680&scoped=true"
import script from "./StudentMoreInfoView.vue?vue&type=script&lang=js"
export * from "./StudentMoreInfoView.vue?vue&type=script&lang=js"

import "./StudentMoreInfoView.vue?vue&type=style&index=0&id=f4c1f680&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4c1f680"]])

export default __exports__